import(/* webpackMode: "eager" */ "/root/repo/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/bettor/performance-chart.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/bettor/performance.module.css");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/bettor/metrics.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default","FollowActions"] */ "/root/repo/client/src/components/bettor/relationship-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/global/become-a-seller.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/layout/subnav.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager" */ "/root/repo/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/primitives/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/repo/client/src/components/team/logo.tsx");
